// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FQab","top":"styles_top__6L_l2","left":"styles_left__LJryM","description":"styles_description__3w-cm"};